import { render, staticRenderFns } from "./ZoneManagementMinimalized.vue?vue&type=template&id=e135b95e"
import script from "./ZoneManagementMinimalized.vue?vue&type=script&lang=js"
export * from "./ZoneManagementMinimalized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports